import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PhoneForwarded, Check } from "lucide-react";
import { toast } from "sonner";
import { fmtDate } from "@/components/DatePicker";

export function FollowUpReminders() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  const load = () => api.get("/tax-impound/follow-ups", { params: { days: 7 } }).then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, []);
  if (!d || d.items.length === 0) return null;
  const done = async (f) => { try { await api.post(`/tax-impound/batches/${f.batch_id}/abatement/call/${f.call_id}/done`, null, { params: { item_key: f.item_key } }); toast.success("Follow-up cleared"); load(); } catch { toast.error("Could not update"); } };
  return (
    <Card className="p-4 sm:p-5 space-y-3" data-testid="follow-up-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div><h3 className="font-display font-semibold flex items-center gap-2"><PhoneForwarded className="w-4 h-4 text-primary" /> Agency callbacks due</h3><p className="text-xs text-muted-foreground">Follow-ups promised on abatement calls · {d.overdue > 0 && <span className="text-rose-600 font-semibold">{d.overdue} overdue · </span>}{d.today} today · next 7 days</p></div>
        <button data-testid="follow-up-open" onClick={() => navigate("/tax-impound")} className="text-xs text-primary hover:underline">Open abatement tracker</button>
      </div>
      <ul className="divide-y divide-border rounded-lg border border-border" data-testid="follow-up-list">
        {d.items.map((f) => (
          <li key={f.call_id} data-testid={`follow-up-${f.call_id}`} className="flex items-center gap-3 p-2.5 text-sm">
            <div className={`text-xs font-mono-num font-semibold w-20 shrink-0 ${f.overdue ? "text-rose-600" : "text-foreground"}`}>{fmtDate(f.follow_up_date)}{f.overdue && <div className="text-[10px]">overdue</div>}</div>
            <div className="min-w-0 flex-1"><div className="font-medium truncate">{f.company_name} · {f.agency} · Form {f.form}</div><div className="text-xs text-muted-foreground truncate">{f.next_step || "Follow up on abatement request"}{f.rep && ` · spoke with ${f.rep}`}{f.reference && ` · ref ${f.reference}`}</div></div>
            <Button size="sm" variant="outline" className="h-7 text-xs" data-testid={`follow-up-done-${f.call_id}`} onClick={() => done(f)}><Check className="w-3 h-3 mr-1" /> Done</Button>
          </li>))}
      </ul>
    </Card>
  );
}
